import React, { useState, useEffect, useCallback } from "react";
// import { get, apiUrl } from "../../../services/apiservices";
import "./device-list.css";
import dock from "../../assets/svg/dock.svg";
import search from "../../assets/svg/search.svg";
import edit from "../../assets/svg/edit.svg";
import del from "../../assets/svg/delete.svg";
import { format } from "date-fns";
import { Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import ReactPaginate from "react-paginate";
import "react-datepicker/dist/react-datepicker.css";
import SearchWithAPI from "../searchbox/searchbox.js";
import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import lar from "../../assets/svg/lar.svg";
import rar from "../../assets/svg/rar.svg";
import DeleteModal from "../common/delete-modal.js";
import mawalog from "../../assets/svg/mawaloglogo.svg";
import DeviceCreateModal from "./device-create-modal.js";
import deviceIcon from "../../assets/svg/devices.svg";
import { getDeviceListApi } from "./device-api.js";
import { FiCopy } from 'react-icons/fi';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

export default function DeviceList() {
  const [sortByField, setSortByField] = useState("");
  const [sortBy, setSortBy] = useState("");

  const [selectedValue, setSelectedValue] = useState("");
  const [count, setCount] = useState(0);
  const [sortField, setSortField] = useState("");
  const [sortDir, setSortDir] = useState("");

  const [searchText, setSearchText] = useState("");
   const [deviceType, setDeviceType] = useState("Signage");

  const handleChange = (e) => {
    const value = e.target.value;
    setSelectedValue(value);

    if (value) {
      const [field, dir] = value.split(" ");
      setSortField(field);
      setSortDir(dir);
    } else {
      setSortField(""); // Default sort
      setSortDir("");
    }
  };
  //filter
  const [selectedLocation, setSelectedLocation] = useState(null);

  const handleLocationChange = (selectedOptions) => {
    console.log(selectedOptions);
    setSelectedLocation(selectedOptions);
  };

  


  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };


  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const fromCreatedDate = startDate ? format(startDate, "yyyy-MM-dd") : "";
  const toCreatedDate = endDate ? format(endDate, "yyyy-MM-dd") : "";

  //filter over

  const apiAdminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const apiUrl = process.env.REACT_APP_API_URL;

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("dock");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [signageCount, setSignageCount] = useState(0);
  const [domainCount, setDomainCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [devices, setDevices] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filterParams, setFilterParams] = useState({
    createdDate: "",
    sortBy: "",
    selectedUser: "",
    date: "",
  });

  const [deviceId, setDeviceId] = useState(null);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  useEffect(() => {
    if (deviceId != null) {
      setIsModalOpen(true);
    }
  }, [deviceId]);
  const closeModal = () => {
    setDeviceId(null);
    setIsModalOpen(false);
  };
  const closeViewModal = () => {
    setViewModal(false);
  };

  const [selectedIds, setSelectedIds] = useState([]);

  const toggleSelect = (id) => {
    setSelectedIds((prev) => (prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]));
  };

  const toggleSelectAll = () => {
    if (selectedIds.length === devices.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(devices.map((row) => row.id));
    }
  };
 

  const calculateDateRange = (filter) => {
    const today = new Date();
    let startDate, endDate;

    switch (filter) {
      case "This week":
        startDate = new Date(today.setDate(today.getDate() - today.getDay()));
        endDate = new Date(today.setDate(startDate.getDate() + 6));
        break;
      case "Last week":
        startDate = new Date(today.setDate(today.getDate() - today.getDay() - 7));
        endDate = new Date(today.setDate(startDate.getDate() + 6));
        break;
      case "This month":
        startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;
      case "Last month":
        startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        endDate = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      default:
        startDate = null;
        endDate = null;
    }

    return { startDate, endDate };
  };

  const handlePageClick = useCallback((event) => {
    const newOffset = (event.selected * itemsPerPage) % devices.length;
    console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
    setItemOffset(event.selected);
  }, []);

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setItemOffset(0);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setItemOffset(0);
  };

  const handleSortChange = (sortOption) => {
    setSortBy(sortOption);

    // Force a refetch by resetting offset
    setItemOffset(0);
  };

  const handleFilterApply = (filters) => {
    // Update sortBy state if it changed in filter
    if (filters.sortBy) {
      setSortBy(filters.sortBy);
    }

    setFilterParams({
      ...filters,
      date: filters.createdDate ? "" : filters.date,
      createdDate: filters.date ? "" : filters.createdDate,
    });
    setIsFilterOpen(false);
    setItemOffset(0);
  };


  useEffect(() => {
    
      getDeviceList();
   
  }, [searchText, sortField, sortDir, itemsPerPage, itemOffset, selectedLocation, startDate, endDate]);

  useEffect(() => {
    getDeviceList();
  }, [deviceType,])
  const getDeviceList = async () => {
    try {
      const response = await getDeviceListApi(`search=${searchText}&limit=${itemsPerPage}&skip=${itemOffset * itemsPerPage}&sort_field=${sortField}&sort_dir=${sortDir}&type=${deviceType}&from_date=${fromCreatedDate}&to_date=${toCreatedDate}`);
      if (response.data.success === true) {
        setDevices(response.data.devices);
        setCount(response.data.totalrecords);
        setPageCount(response.data.totalpages);
        setSignageCount(response.data.signages)
        setDomainCount(response.data.domains)
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const onSuccessDevice = async (response) => {
    setIsModalOpen(false);
     setDeviceId(null);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    getDeviceList();
  };
  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isOpenBulkDelete, setIsOpenBulkDelete] = useState(false);
  useEffect(() => {
    if (deleteId != null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);

  const cancelDelete = () => {
    setDeleteId(null);
    setIsOpenDelete(false);
  };
  const onSuccessDelete = (response) => {
    setDeleteId(null);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    if (response.success === true) {
      setIsOpenDelete(false);
      getDeviceList();
    }
  };

  const cancelBulkDelete = () => {
    setIsOpenBulkDelete(false);
  };
  const onSuccessBulkDelete = (response) => {
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    if (response.success === true) {
      setSelectedIds([]);
      setIsOpenBulkDelete(false);
      getDeviceList();
    }
  };

  const handleCopy = async (textToCopy) => {
    try {
      await navigator.clipboard.writeText(textToCopy);  
          setSnackbarMessage("Copied!");
    setSnackbarStatus(true);
    handleSnackbarShow();   
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };


  return (
    <div className="dockmaster-container">
      {isOpenDelete && <DeleteModal deleteUrl={`device/delete/${deleteId}`} onSuccess={onSuccessDelete} onCancel={cancelDelete} />}
      {isOpenBulkDelete && <DeleteModal ids={selectedIds} deleteUrl={`device/bulkDelete`} onSuccess={onSuccessBulkDelete} onCancel={cancelBulkDelete} />}
      {/* Header */}
     
      {/* Card Content */}
      <div className="dockmaster-card">
        {/* Tabs */}
        <div className="px-3 py-2 custom-shadow style-justify-between">
<div className="style-justify-start">
<div className="devices-icon style-justify-center">
   <img src={deviceIcon} alt="devices" />
</div>
<div className="ms-2">
<div className="font16-700-21272C">Devices</div>
<div className="font16-700-66737E">You can add, edit and manage them.</div>
</div>
</div>

<div className="style-justify-end">
 <div className="search-box flex items-center border rounded-md w-full md:w-auto">
                <span className="icon mr-2">
                  <img src={search} alt="search" className="search-icon w-4 h-4" />
                </span>
                <input type="text" placeholder="Search" className="outline-none w-full" value={searchText} onChange={(e) => setSearchText(e.target.value)} />
              </div>
              <button className="ms-2 addbtn bttn flex items-center bg-blue-600 text-white rounded-md" onClick={() => setIsModalOpen(true)}>
                {/* <span className="icon">
                  <img src={plus} alt="add" className="btn-icon w-4 h-4" />
                </span> */}
                Add
              </button>
              {selectedIds.length > 0 && (
                <button
                  className="ms-1 addbtn bttn flex items-center bg-blue-600 text-white rounded-md"
                  onClick={() => {
                    setIsOpenBulkDelete(true);
                  }}>
                  {/* <span className="icon">
                  <img src={plus} alt="add" className="btn-icon w-4 h-4" />
                </span> */}
                  Delete
                </button>
              )}
</div>
        </div>
      <div className="px-3 mt-3 style-justify-start" style={{ flexWrap: 'wrap', gap: '8px' }}>
            <div onClick={()=>{
               setDeviceType('Signage')
                  }} className={`cursor-pointer px-4 style-justify-center ${deviceType==='Signage'?'device-active-tab':'device-inactive-tab'}`}>
               Signage ({signageCount})
            </div>
            <div onClick={()=>{  
               setDeviceType('Domain')             
               }} className={`cursor-pointer px-4 style-justify-center ${deviceType==='Domain'?'device-active-tab':'device-inactive-tab'}`}>
               Domain ({domainCount})
            </div>
         </div>

        {/* Table */}
        <div className="mt-2 table-container table-responsive">
          <table className="dock-table">
            <thead>
              <tr>
                <th style={{width:'76px'}}>
                  <input type="checkbox" checked={selectedIds.length === devices.length} onChange={toggleSelectAll} />
                </th>
                <th style={{width:'96px'}}>S.No</th>
                <th>Signage ID</th>
                <th>Device Name</th>
                <th>Group Name</th>
                <th>Last Active</th>
                <th>Status</th>
                <th>Created At</th>
              </tr>
            </thead>
            <tbody>
              {devices.length > 0 ? (
                devices.map((device, i) => (
                  <tr key={i} onClick={() => { /* setDockMasterId(device.id); setViewModal(true); */ }}>
                    <td>
                      <input type="checkbox" checked={selectedIds.includes(device.id)} onChange={() => toggleSelect(device.id)} />
                    </td>
                     <td className="truncate-cell">{(itemOffset * itemsPerPage)+(i+1)}</td>
                    <td className="truncate-cell">{device.signage_code || "N/A"}</td>
                    <td className="truncate-cell">{device.device_name || "N/A"}</td>
                    <td className="truncate-cell">{device.group_name || "N/A"}</td>
                    <td className="truncate-cell">{device.last_active || "N/A"}</td>
                    <td className="truncate-cell">
                      {device.status === true ? "Active" : "InActive"}
                    </td>

                    <td className="truncate-cell hover-time-cell group">
                      <span className="time-value">{device.updated_date || "N/A"}</span>
                      <div className="time-actions">
                         {/* {device.url!=null && device.url!=="" &&(<button
                          onClick={() => {
                            handleCopy(device.url);
                          }}
                          className="icon-btn edit-btn"
                          data-tooltip-id="copyTip"
                          title="Copy">
                          <FiCopy size={20} />
                        </button>)} */}
                        {device.url!=null && device.url!=="" &&(<div>
                          <button
                         className="icon-btn edit-btn"
      
        title={device.url}
        onClick={() => {
                            handleCopy(device.url);
                          }}
       
      >
        <FiCopy size={16} />
      </button>
      
      </div>)}
                        
                        <button
                          onClick={() => {
                            setDeviceId(device.id);
                          }}
                          className="icon-btn edit-btn"
                          title="Edit">
                          <img src={edit} alt="Edit" className="icon-img" />
                        </button>
                        <button
                          onClick={() => {
                            setDeleteId(device.id);
                          }}
                          className="icon-btn delete-btn"
                          title="Delete">
                          <img src={del} alt="Delete" className="icon-img" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center py-4 text-gray-500 text-base">
                    {filterParams.date || filterParams.createdDate ? (dock?.created_at ? "No data available for selected date range" : "No date available") : "No data available"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <Row style={{ marginTop: "16px" }}>
          <Col>
            <div className="d-flex align-items-center justify-content-start mx-3">
              <span
                style={{
                  fontFamily: "Epilogue",
                  fontSize: "13px",
                  fontWeight: "500",
                  color: "#212129",
                }}>
                Records per page :
              </span>
              <select
                className="select3"
                id="perpage"
                value={itemsPerPage}
                onChange={(event) => {
                  setItemsPerPage(event.target.value);
                }}
                style={{
                  cursor: "pointer",
                  fontFamily: "Epilogue",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "18.9px",
                  color: "#212129",
                  width: "56px",
                  height: "24px",
                  borderRadius: "10px",
                  border: "0.7px solid #E5E5E5",
                  padding: "0 4px",
                  backgroundColor: "#FFFFFF",
                }}>
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </Col>
          <Col>
            <div className="d-flex justify-content-end">
              <ReactPaginate previousLabel={<img src={lar} className="ar3" alt="previous" />} nextLabel={<img src={rar} className="ar3" alt="next" />} breakLabel={"..."} pageCount={pageCount + 1} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handlePageClick} containerClassName={"pagination"} activeClassName={"active"} />
            </div>
          </Col>
        </Row>
        <div style={{ textAlign: "center", marginTop: "30px", fontWeight: "400", fontSize: "12px", color: "#172B4D" }}>
          Powered by{" "}
          <span>
            <img src={mawalog} />
          </span>
        </div>
      </div>

      {/* Modal */}
      
      {isModalOpen && <DeviceCreateModal deviceId={deviceId} onSuccess={onSuccessDevice} setIsModalOpen={setIsModalOpen} onCancel={closeModal} />}
    

     
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
}
